import type {Schemas} from 'domainTypes/dto';
import type {Column} from '../types';

export const mapAvailableColumn = (
  dto: Schemas.Column,
  isWorkType?: boolean,
): Column => {
  return {
    ...dto,
    codelistId: dto.codelistId as Schemas.CodelistDto['id'],
    workColumn: isWorkType,
  };
};
